export default "__VITE_ASSET__ec2de74f__"